import mfaImage from "@/assets/mfa-image.svg";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import PasswordInput from "../input-password";
import type { IMfaDisableResponse } from "@/hooks/use-mfa";
import { useMMfaDisable } from "@/hooks/use-mfa";
import { useContext, useState } from "react";
import useUserInfo from "@/hooks/use-user-info";
import { MFAContext, MfaViewState } from "@/context/mfa-provider";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { ErrorNotificationType } from "../error-notification";
import { useNotificationError } from "@/context/error-provider";
import { STORAGE_KEY } from "@/constants";

const DisableMfa = () => {
  const { setViewState } = useContext(MFAContext);
  const [password, setPassword] = useState("");
  const userInfo = useUserInfo();
  const mfaDisableQuery = useMMfaDisable();
  const { addError } = useNotificationError();

  const handleDisableMfa = (e: React.FormEvent) => {
    e.preventDefault();
    mfaDisableQuery.mutate(
      {
        username: userInfo.username,
        password,
        accessToken: userInfo.accessToken,
      },
      {
        onSuccess: (response: IMfaDisableResponse) => {
          const storedAuthData = sessionStorage.getItem(STORAGE_KEY.AUTH_DATA);
          if (storedAuthData) {
            const authData = JSON.parse(storedAuthData);
            const updatedAuthData = {
              ...authData,
              // is_mfa_enabled: !response.isMfaDisabled,
              user: {
                ...authData.user,
                is_mfa_enabled: !response?.isMfaDisabled,
              },
            };
            sessionStorage.setItem(
              STORAGE_KEY.AUTH_DATA,
              JSON.stringify(updatedAuthData),
            );
          }
          if (!response.isMfaDisabled) {
            addError({
              message: response.message,
              type: ErrorNotificationType.ERROR,
            });
          } else {
            addError({
              message: response.message,
              type: ErrorNotificationType.INFO,
            });
          }

          setViewState(MfaViewState.COMPLETE);
        },
      },
    );
  };

  return (
    <form className="flex size-full flex-col justify-between gap-8">
      <div className="grid grid-cols-1 place-items-center gap-6">
        <img src={mfaImage} className="size-20" alt="" />
        <Label className="text-lg font-bold">Multi Factor Authentication</Label>
        <div className="flex flex-col gap-1 text-center">
          <Label className="text-sm/6">
            Please Enter your password to disable MFA
          </Label>
        </div>
      </div>
      <div className="flex flex-col gap-2">
        <Label>Password</Label>
        <PasswordInput
          id="password"
          placeholder="Password"
          value={password}
          onChange={setPassword}
        />
      </div>
      <div className="flex justify-center gap-4">
        {/* <Button type="submit" className="w-32 rounded-sm">
          Disable
        </Button> */}
        <Dialog>
          <DialogTrigger asChild>
            <Button type="button" className="w-32 rounded-sm">
              Disable
            </Button>
          </DialogTrigger>
          <DialogContent className="sm:max-w-[425px]">
            <DialogHeader>
              <DialogTitle>Disable Multi-Factor Authentication</DialogTitle>
              <DialogDescription>
                Are you sure you want to disable multi-factor authentication?
                This will reduce the security of your account.
              </DialogDescription>
            </DialogHeader>
            <DialogFooter>
              <DialogClose asChild>
                <Button
                  variant="outline"
                  onClick={() => setViewState(MfaViewState.COMPLETE)}
                >
                  Cancel
                </Button>
              </DialogClose>
              <Button onClick={handleDisableMfa}>OK</Button>
            </DialogFooter>
          </DialogContent>
        </Dialog>
      </div>
    </form>
  );
};

export default DisableMfa;
